import type { Cookies as CookiesType } from "@packages/framework";
import Cookies from "js-cookie";
import z from "zod";

import { consoleErrorPackagesSdk } from "../../../utils/consoleErrorPackagesSdk";
import type { CookieKey } from "../types/cookieKey.types";
import type { CookieSchema } from "../types/cookieSchema.types";

export type GetCookieProps = {
  cookies?: Omit<CookiesType, "delete">;
  key: CookieKey;
  schema?: CookieSchema;
};

export const getCookie = <T extends any = string>({
  cookies,
  key,
  schema,
}: GetCookieProps): T => {
  const cookie = cookies ? cookies.get(key)?.value : Cookies.get(key);

  if (!cookie) return null;

  try {
    const value = (schema ?? z.string()).parse(
      cookie.startsWith("[") || cookie.startsWith("{")
        ? JSON.parse(cookie)
        : cookie,
    );

    if (value === "false") return false as T;
    if (value === "true") return true as T;

    if (typeof value === "object") return value as T;

    if (!isNaN(Number(value))) return Number(value) as T;

    return value as T;
  } catch (error) {
    consoleErrorPackagesSdk({
      error,
      heading: `Could not validate ${key} cookie`,
    });
    return null;
  }
};
